import React from 'react';

import AboutPage from 'components/AboutPage/AboutPage';
import websitePage from 'hoc/websitePage/websitePage';

import SectionPress from './patterns/SectionPress/SectionPress';
import SectionNubankers from './patterns/SectionNubankers/SectionNubankers';
import SectionPillars from './patterns/SectionPillars/SectionPillars';
import SectionPresentation from './patterns/SectionPresentation/SectionPresentation';

function Careers() {
  return (
    <AboutPage>
      <SectionPresentation />
      <SectionPillars />
      <SectionNubankers />
      <SectionPress />
    </AboutPage>
  );
}

export default websitePage({
  routeKey: 'CAREERS',
})(Careers);
